import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

import Axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'

import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'


import VueHtmlToPaper from 'vue-html-to-paper'

import wysiwyg from "vue-wysiwyg"
import "vue-wysiwyg/dist/vueWysiwyg.css"

import VueApexCharts from 'vue-apexcharts'

//import VueKatex from 'vue-katex';
//import 'katex/dist/katex.min.css';

//Vue.use(VueKatex, {
//    globalOptions: {
//        throwOnError: false
//      //... Define globally applied KaTeX options here
//    }
//  })

Vue.use(VueApexCharts)


const { htmlToText } = require('html-to-text')


Vue.use(VueHtmlToPaper,{
    "name": "_blank",
    "specs": [
        "fullscreen=yes",
        "titlebar=yes",
        "scrollbars=yes"
    ],
    "timeout": 1000,
    "autoClose": true,
    "windowTitle": "Vue Html To Paper - Vue mixin for html elements printing."
})

Vue.use(wysiwyg, {
    hideModules: {
        'justifyLeft': true,
        'justifyCenter': true,
        'justifyRight': true,
        'headings': true,
        'link': true,
        'code': true,
        'image': true,
        'table': true,
        'separator': true,
    },
})

Vue.config.productionTip = false


Vue.prototype.$swal = Swal
Vue.prototype.$http = Axios
Vue.prototype.Axios = Axios
Vue.prototype.moment = moment

//numeral.locale('fr')

Vue.prototype.$html2text = htmlToText

Vue.prototype.$numeral = numeral

Vue.prototype.$url= window.location.origin



// Configuración para AXIOS
if (process.env.NODE_ENV == 'development'){
    Axios.defaults.baseURL = 'http://localhost:9999/secahSf/api'
    Vue.prototype.$baseUrl = 'http://localhost:9999/secahSf/'
    //Axios.defaults.baseURL = 'http://localhost:9999/api'
    //Vue.prototype.$baseUrl = 'http://localhost:9999/'
} else {
    Axios.defaults.baseURL = 'http://secahsf.ath.cx:8081/secahsf/api'
    Vue.prototype.$baseUrl = 'http://secahsf.ath.cx:8081/secahsf/'
}

Axios.defaults.timeout = 100000

moment.locale('es_MX')


if (localStorage.getItem('token')){
    Vue.prototype.$http.defaults.headers.common['X-Auth-Token']=localStorage.getItem('token')
}

// Esto es para que funciones el this.http en los módulos del store
store.$http = Vue.prototype.$http
store.Axios = Axios

store.$router = router
  
router.beforeEach((to, from, next) => {
    // ----------------------------------------------------------------------------------------
    // La limpieza que se tiene que hacer de los datos del store antes de cargar cada vista
    // ----------------------------------------------------------------------------------------
    
    //Se carga en este punto la actualización de la fecha para los date-picker (en el store de security)
    store.commit('security/SET_ESTA_FECHA_MAX')

    store.commit('cirugia/CLEAR_TIMEOUT')


    if (to.path == '/'){
        //console.log(localStorage.getItem('username'))
        if (localStorage.getItem('username')){
            next('/principal')
        } else {
            next()
        }
        
    } else {
        if(to.meta.requiresAuth){
            store.dispatch('security/cargaAntes', {to:to, from:from, next:next})
        } else {
            next()
        }
    }

})

 Vue.config.productionTip = false
 
 new Vue({
    store,
    router,
    vuetify,
    Swal,
    numeral,
    //VueKatex,
    render: h => h(App)
  }).$mount('#app')
  
